import { render } from "./ExclusiveOffer.vue?vue&type=template&id=f97228a6&scoped=true"
import script from "./ExclusiveOffer.vue?vue&type=script&lang=js"
export * from "./ExclusiveOffer.vue?vue&type=script&lang=js"

import "./ExclusiveOffer.vue?vue&type=style&index=0&id=f97228a6&lang=scss&scoped=true"

import exportComponent from "/home/pomelos/Projects/stowy-web-prod/stowy-web/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f97228a6"]])

export default __exports__